import React, { useState, useRef, useEffect } from "react";
import { FiMoreVertical } from "react-icons/fi";
import "./index.scss";
import { MoreHorizontal } from "../../../../assets/icons/MoreHorizontal";

const RowActions = ({ actions }) => {
  const [open, setOpen] = useState(false);
  const ref = useRef();

  // Fermer si clic en dehors
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (ref.current && !ref.current.contains(event.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div className="row-actions" ref={ref}>
      <button className="btn-actions" onClick={() => setOpen(!open)}>
        <MoreHorizontal />
      </button>

      {open && (
        <div className="actions-menu shadow">
          {actions.map((action, index) => (
            <div
              key={index}
              className="action-item"
              onClick={() => {
                setOpen(false);
                action.onClick();
              }}>
              {action.label}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default RowActions;
